// extracted by mini-css-extract-plugin
export default {"welcome":"Dashboard_welcome__CJLZX"};